import ElAddPageList from './add-page-list'
import AddPageCell from './add-page-cell'
export default {
  name: 'ElAddPageList',
  components: {
    AddPageCell,
    ElAddPageList
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    }
  },
  render() {
    const defaultCol = {
      span: 8
    }
    const list = this.options.map(option => {
      if (Array.isArray(option)) {
        return <el-add-page-list data={this.data} options={option} row={this.row} on-change={this.change} />
      }
      return (
        <el-col props={option.col || defaultCol}>
          <add-page-cell data={this.data} option={option} row={this.row} on-change={this.change} />
        </el-col>
      )
    })
    return (
      <el-row props={this.row}>
        { list }
      </el-row>
    )
  }
}
